import React, { useState } from 'react';
import { Checkmark } from './Checkmark';
import './Checkbox.scss';

interface CheckboxProps {
  disabled?: boolean | 'disabled';
  handleChange: ([]) => void;
  label: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  disabled,
  label,
  handleChange
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const randomNumber = Math.ceil(Math.random() * 1000) * Date.now();

  return (
    <span
      tabIndex={0}
      aria-checked={isChecked}
      id={`ads-checkbox--${randomNumber}`}
      data-testid="ads-checkbox"
      className={`ads-checkbox ${disabled ? 'ads-checkbox__disabled' : ''}`}
      onClick={() => {
        setIsChecked(!isChecked);
        handleChange([`${!isChecked ? 'checked' : 'unchecked'}`, `${label}`]);
      }}
      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === ' ') {
          setIsChecked(!isChecked);
          handleChange([`${!isChecked ? 'checked' : 'unchecked'}`, `${label}`]);
        }
      }}
    >
      <label
        className="ads-checkbox__label"
        htmlFor={`ads-checkbox--${randomNumber}`}
      >
        {label}
      </label>

      <input
        className="ads-checkbox__input"
        type="checkbox"
        tabIndex={-1}
        aria-hidden="true"
        value={`${isChecked}`}
        name={`${label}`}
        role="checkbox"
      />
      <span
        className={`ads-checkbox__checkmark ${
          isChecked ? 'ads-checkbox__checkmark--bg' : ''
        }`}
      >
        <span className="ads-checkbox__checkmark-icon">
          {isChecked && <Checkmark />}
        </span>
      </span>

      <span className="ads-checkbox--focus" />
    </span>
  );
};
